import jwt from 'jsonwebtoken';

export const GenerateTemporaryImagePathForVehicle = (
  name,
  parentPath,
  uuid,
) => {
  const userData = JSON.parse(localStorage.getItem('userData'));

  const { token } = userData;
  const jwtDecodeToken = jwt.decode(token);

  if (parentPath === 'profileImg') {
    return `${parentPath}/${jwtDecodeToken.userId}/${uuid}/${name}`;
  }

  if (parentPath === 'accountProfile') {
    return `${parentPath}/${jwtDecodeToken.businessId}/${uuid}/${name}`;
  }

  return `${parentPath}/${
    jwtDecodeToken?.businessId ||
    userData?.userStore?.['_id'] ||
    userData.businessId
  }/${uuid}/${name}`;
};

export const GenerateImagePathForUser = (name) => {
  const userData = JSON.parse(localStorage.getItem('userData'));

  const { token } = userData;
  const jwtDecodeToken = jwt.decode(token);

  const customerId = localStorage.getItem('customerId');
  return `signature/${
    jwtDecodeToken.businessId || userData?.userStore?.id
  }/${customerId}/${name}`;
};

export const GenerateTemporaryImagePath = (
  name,
  parentPath,
  timeStampForImage,
  subModule,
) => {
  const userData = JSON.parse(localStorage.getItem('userData'));

  const { token } = userData;
  const jwtDecodeToken = jwt.decode(token);
  if (subModule) {
    return `${parentPath}/${
      jwtDecodeToken?.businessId || userData?.userStore?.id
    }/${timeStampForImage}/${subModule}/${name}`;
  }
  return `${parentPath}/${
    jwtDecodeToken?.businessId || userData?.userStore?.id
  }/${timeStampForImage}/${name}`;
};
